import { EventName } from '@lit/react';
import { BlocksSideMenu } from 'blocks-nextjs/blocks-web-components/components/side-menu/side-menu';
import { BlocksNavSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

/**
 * @deprecated - This component `CatSideMenu` has been deprecated and the updated version will be available with name `CatSideMenuLabs`. New component will be found under labs folder from Minor Release 3.10.0, `CatSideMenu` will be removed in 5.0 major release.
 */

export const CatSideMenu = createComponent({
  react: React,
  tagName: 'cat-side-menu',
  elementClass: BlocksSideMenu,
  events: {
    onBlSidemenuitemSelect: 'bl-sidemenuitem-select' as EventName<BlocksNavSelectEvent>
  }
});
